import axios from 'axios';
import { axiosConfig } from '../config';
import * as I from '../../models/configuration';

export const getDiscoveryConfig = async (): Promise<I.ConfigResponse | I.ConfigError> => {
  try {
    if (!localStorage.getItem('config')) {
      const apiUrl = process.env.NODE_ENV === 'development' ? `${window.location.protocol}//${window.location.hostname}:5100/api/v1/Configuration` : `${window.location.protocol}//${window.location.host}/api/v1/Configuration`;
      
      const res = await axios.get(
        `${apiUrl}`,
        axiosConfig
      );
      const { data } = res;
      localStorage.setItem('config', JSON.stringify(data));
      return data;
    } else {
      return {
        error: 'err',
        code: 'key err'
      };
    }
  } catch (error) {
    return {
      error: error.message,
      code: error.response.data.StatusCode
    };
  }
};